var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d64f4114676cf0e66bbd6352cd29ae74e3576346"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["poryadok-ru@sentry"]={id:"d64f4114676cf0e66bbd6352cd29ae74e3576346"};
      